import { Helmet } from 'react-helmet';
import GuidesAndReportsList from '../components/GuidesAndReports/GuidesAndReportsList';
import pagesJsonLD from '../constants/pagesJsonLD';
import './CaseStudiesListing.css';

const GuidesAndReportsListing = () => {
  return (
    <div className="case-studies-content-for-each">
      <Helmet>
        <title>Releva AI | Reports and Guides</title>
        <meta
          name="description"
          content="Discover how Releva.ai leverages advanced AI to automate and optimize your e-commerce operations, driving growth, efficiency, and personalized customer experiences."
        />
        <script type="application/ld+json">{JSON.stringify(pagesJsonLD.contentLibraryPage)}</script>
      </Helmet>
      <section className="case-studies-title-parent">
        <h1 className="case-studies2">Reports and Guides</h1>
      </section>
      <section className="case-studies-description-paren">
        <div className="discover-how-releva">
          Discover expert insights and actionable guides for commanding your customer journey.
        </div>
      </section>

      <div className="case-studies-content-for-each-inner">
        <div className="frame-child14" />
      </div>
      <GuidesAndReportsList category={'All'} />
    </div>
  );
};

export default GuidesAndReportsListing;
